module.exports = __webpack_public_path__ + "img/xiaokuang.aab889d8.png";